import { render, staticRenderFns } from "./BlockedIPsTable.vue?vue&type=template&id=2948772e&"
import script from "./BlockedIPsTable.vue?vue&type=script&lang=js&"
export * from "./BlockedIPsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports